export default __webpack_public_path__ + "static/Riposo-de2cc0ce305cd8c5d7135fa766696e0c.jpg";